import {
    AGE_CATEGORIES_SUCCESS,
    AGE_CATEGORIES_REQUEST,
    AGE_CATEGORIES_FAILURE,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
};

export const ageCategoriesListReducer = (state = initialState, action) => {
    const {type, data} = action;
    switch (type) {
        case AGE_CATEGORIES_SUCCESS: { return {
            ...state,
            isFetched: true,
            isFetching: false,
            data: preserveArrayReference(state.data, data),
        }}

        case AGE_CATEGORIES_REQUEST: { return {
            ...state,
            isFetching: true,
        }}

        case AGE_CATEGORIES_FAILURE: { return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
